/**
 * @generated SignedSource<<94cc74431f0babfeb1555e6740067812>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateTimeLockInput = {
  companyId?: string | null;
  lockedPeriodYear?: number | null;
  lockedPeriodMonth?: number | null;
  lockedPeriodDay?: number | null;
  personId?: string | null;
  useTimeLocking?: boolean | null;
  excludeFromCompanyLockedPeriod?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type updateTimeLockMutation$variables = {
  input: UpdateTimeLockInput;
};
export type updateTimeLockMutation$data = {
  readonly updateTimeLock: {
    readonly company: {
      readonly id: string;
      readonly lockedPeriodYear: number | null;
      readonly lockedPeriodMonth: number | null;
      readonly lockedPeriodDay: number | null;
      readonly useTimeLocking: boolean | null;
    } | null;
    readonly person: {
      readonly id: string;
      readonly excludeFromCompanyLockedPeriod: boolean | null;
    } | null;
  } | null;
};
export type updateTimeLockMutation = {
  variables: updateTimeLockMutation$variables;
  response: updateTimeLockMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateTimeLockPayload",
    "kind": "LinkedField",
    "name": "updateTimeLock",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "company",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lockedPeriodYear",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lockedPeriodMonth",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lockedPeriodDay",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "useTimeLocking",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Person",
        "kind": "LinkedField",
        "name": "person",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "excludeFromCompanyLockedPeriod",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateTimeLockMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateTimeLockMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "8f50ff668894e689ea3244b424a4e267",
    "id": null,
    "metadata": {},
    "name": "updateTimeLockMutation",
    "operationKind": "mutation",
    "text": "mutation updateTimeLockMutation(\n  $input: UpdateTimeLockInput!\n) {\n  updateTimeLock(input: $input) {\n    company {\n      id\n      lockedPeriodYear\n      lockedPeriodMonth\n      lockedPeriodDay\n      useTimeLocking\n    }\n    person {\n      id\n      excludeFromCompanyLockedPeriod\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d9320036570eddb1f39d60d57cb240a7";

export default node;
